import { lazy } from "react";

const Chatbot = lazy(() => {
  return import("containers/chatBot");
});

const Chats = lazy(() => {
  return import("containers/chatBot/components/chat/chat");
});

const routes = [
  {
    path: "/chatbot",
    element: <Chatbot />,
  },
  {
    path: "/chatbot/chat/*",
    element: <Chats />,
  },
];

export default routes;
